<template>
  <b-card-code>
    <div class="content-container">
      <div v-if="!isShowIframe" class="text-center">
        <img v-if="settingsBIPage !== null && settingsBIPage.type === 'image'" :src="settingsBIPage.content" alt="Aviso BI" />

        <span v-if="settingsBIPage !== null && settingsBIPage.type === 'content'">
          {{ settingsBIPage.content }}
        </span>

        <iframe
          v-if="settingsBIPage !== null && settingsBIPage.type === 'youtube'"
          width="1050" height="600"
          :src="settingsBIPage.content"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin" allowfullscreen
        ></iframe>
      </div>

      <b-tabs v-if="isShowIframe">
        <b-tab v-for="(payload, index) in biConfigurations.payload" :key="index" :title="payload.tab_name">
          <iframe
            class="iframe-bi"
            :src="getUrlIFrame(payload)"
            width="100%"
            height="400"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </b-tab>
      </b-tabs>

    </div>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import jwt from 'jsonwebtoken'

export default {
  components: {
    BCardCode,
  },
  data() {
    return {
      isShowIframe: false,
      iframeUrl: '',
      currentPromotion: {},
      settingsBIPage: null,
      dashboards: [],
      biConfigurations: null,
    }
  },
  mounted() {
    this.$http.get('system-settings/page-analytics').then(
      response => {
        if (response.settings !== null) {
          this.settingsBIPage = response.settings
        }
      },
    )
    this.prepareParams()
  },
  methods: {
    async prepareParams() {
      this.currentPromotion = await this.$user.getCurrentPromotion()
      this.biConfigurations = await this.$http.get(`/promotions/${this.currentPromotion.uuid}/business-inteligence`)
      if (!this.biConfigurations) {
        this.isShowIframe = false
        return
      }
      this.isShowIframe = true
    },
    getUrlIFrame(currentPayload) {
      const METABASE_SITE_URL = process.env.VUE_APP_METABASE_URL
      const METABASE_SECRET_KEY = process.env.VUE_APP_METABASE_KEY

      let properties = '#bordered=true&titled=true'
      if (this.biConfigurations.properties) {
        properties = this.biConfigurations.properties
      }
      const payload = {
        ...currentPayload,
        exp: Math.round(Date.now() / 1000) + (2 * 60 * 60), // 2 horas de expiração
      }
      const token = jwt.sign(payload, METABASE_SECRET_KEY)
      return `${METABASE_SITE_URL}/embed/dashboard/${token}${properties}`
    },
  },
}
</script>
<style>
.content-container {
  height: 1200px;
  overflow: hidden;
  position: relative;
}

.iframe-bi {
  width: 100%;
  height: 1300px;
  border: none;
}
</style>
